import { useMutation } from "react-query";
import nonUserService from "../../services/nonUserService";

const useAddAnonymousIncident = () => 
    useMutation((incident) => nonUserService.addIncident(incident));

export default useAddAnonymousIncident; 
